document.addEventListener('DOMContentLoaded', function() {
    const firstLevelItems = document.querySelectorAll('.main-header__first-level--item');
    const itemBaseHeight = 75; 
    const minHeight = firstLevelItems.length * itemBaseHeight; 

    const subNavWrapper = document.querySelector('.main-header__sub-nav-wrapper');
    subNavWrapper.style.minHeight = `${minHeight}px`;
    subNavWrapper.style.height = `${minHeight}px`;

    firstLevelItems.forEach(firstLevelItem => {
        firstLevelItem.addEventListener('mouseover', function() {
            const secondLevel = firstLevelItem.querySelector('.main-header__second-level');
            const thirdLevel = firstLevelItem.querySelector('.main-header__third-level');

            if (secondLevel && secondLevel.querySelector('.main-header__second-level--item')) {
                secondLevel.classList.add('active');
            }
            if (thirdLevel && thirdLevel.querySelector('.main-header__third-level--item')) {
                thirdLevel.classList.add('active');
            }

            let additionalHeight = 0;
            const itemBaseHeight = 60; 

            if (secondLevel && secondLevel.classList.contains('active')) {
                const secondLevelItems = secondLevel.querySelectorAll('.main-header__second-level--item');
                additionalHeight += Math.max(0, secondLevelItems.length * itemBaseHeight);
            }

            if (thirdLevel && thirdLevel.classList.contains('active')) {
                const thirdLevelItems = thirdLevel.querySelectorAll('.main-header__third-level--item');
                additionalHeight += Math.max(0, thirdLevelItems.length * itemBaseHeight);
            }
            console.log(subNavWrapper)
            subNavWrapper.style.height = `${additionalHeight}px`;
        });

        firstLevelItem.addEventListener('mouseleave', function() {
            const secondLevel = firstLevelItem.querySelector('.main-header__second-level');
            const thirdLevel = firstLevelItem.querySelector('.main-header__third-level');

            if (secondLevel) {
                secondLevel.classList.remove('active');
            }
            if (thirdLevel) {
                thirdLevel.classList.remove('active');
            }

            subNavWrapper.style.height = `${minHeight}px`;
        });
    });
});
